const dictionaries = {
  it: {
    collection: "Collezione",
    search: "Cerca",
    searchPlaceholder: "Cerca borse, cinture, portafogli…",
    account: "Account",
    favorites: "Preferiti",
    cart: "Carrello",
    addToCart: "Aggiungi al carrello",
    buyNow: "Acquista ora",
    soldOut: "Esaurito",
    available: "Disponibile",
    lowStock: "Ultimi pezzi",
    new: "Novità",
    sale: "Promo",
    emptyCart: "Il tuo carrello è vuoto.",
    allCategories: "Tutte le categorie",
  },
};

let locale = "it";
export const setLocale = (l) => { if (dictionaries[l]) locale = l; };
export const t = (key) => dictionaries[locale][key] ?? key;
